import React, { useState, useCallback, useEffect } from 'react';
import { Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage } from 'react-intl';
import { CustomModal, EventEmitter } from '@nile/components';
import ItemsToAdd from './ItemsToAdd';

export function AddProducts(props) {
  const { client, ticket, project, module } = props;
  const [customModal, setCustomModal] = useState(false);
  const closeModal = useCallback(() => {
    setCustomModal(false);
  }, []);
  const openCustomModal = useCallback(() => {
    setCustomModal(true);
  }, []);

  const updateProperties = () => {};
  return (
    <div>
      {props?.newLayout ? (
        <Button plain icon={<SVGIcon name="Add" />} onClick={openCustomModal} />
      ) : (
        <Button onClick={openCustomModal} icon={<SVGIcon name="Add" />}>
          <div className="ellipsis">
            <FormattedMessage id="ticket.details.worklog.addProducts" />
          </div>
        </Button>
      )}

      {customModal && (
        <CustomModal
          open={customModal}
          onClose={closeModal}
          locked={props?.locked}
        >
          <ItemsToAdd
            closeModal={closeModal}
            client={client}
            ticket={ticket}
            project={project}
            module={module}
            locked={props?.locked}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default AddProducts;
